import { tw } from 'utils/classnames'
import { useFeatureIsOn } from 'growthbook'
import { AppRoutes } from '@repo/web-utils/app-routes'

import * as MenuItem from '../menu-item'
import { UserAvatar } from '../avatar'
import { HamburgetMenu } from './hamburger-menu'
import {
  useOnLoginClick,
  useRouterUtil,
  useTranslations,
} from '../../contexts/header-config-context'
import { useIsAuthPending, useIsLoggedIn } from '../../hooks/use-auth'
import { User01Icon } from '../icons/user-01-icon'
import { useUserData } from '@repo/cf-user/contexts/auth'
import { studioBaseUrl } from '../../utils/urls'
import { useIsIpad } from '../../hooks/use-is-ipad'
import { SearchAutocomplete } from '../search'
import { AiSearchSlot } from '../search/ai-search-slot'
import { HeaderCTA } from './header-cta'

export function MobileHeader({ hamburgerMenu }: { hamburgerMenu?: React.ReactNode } = {}) {
  const isLoggedIn = useIsLoggedIn()
  const isAuthLoading = useIsAuthPending()
  const t = useTranslations()
  const onLoginClick = useOnLoginClick()
  const isIpad = useIsIpad()
  const isAiSearchEnabled = useFeatureIsOn('grow-2437-ai-search-experiment')
  const { pathname } = useRouterUtil()
  const isHomepage = /^\/([a-z]{2}\/)?(home2\/)?$/.test(pathname)
  const logoHref = isHomepage ? '/' : '/content/'

  const getAiSearchButton = (query: string) => <AiSearchSlot query={query} />

  const userData = useUserData()

  const profileLink =
    isHomepage && userData
      ? `${studioBaseUrl}/creator/${userData.slug}/`
      : AppRoutes.SOCIAL_CURATED_FEED
  const profileTarget = isHomepage && userData ? '_blank' : undefined

  const renderAccountItems = () => {
    if (isAuthLoading) {
      return null
    }

    return isLoggedIn ? (
      <MenuItem.Link
        href={profileLink}
        target={profileTarget}
        className="h-[54px] flex-col justify-between gap-1 min-[400px]:absolute min-[400px]:left-14"
      >
        <UserAvatar />
        <span className="grow whitespace-nowrap">{t('top_nav.account')}</span>
      </MenuItem.Link>
    ) : (
      <MenuItem.Button
        onClick={onLoginClick}
        className="h-[54px] flex-col justify-between gap-1 min-[400px]:absolute min-[400px]:left-14"
      >
        <User01Icon className="min-h-5" />
        <span className="grow whitespace-nowrap">{t('top_nav.login')}</span>
      </MenuItem.Button>
    )
  }

  return (
    <div
      id="mobile-header"
      className={tw('px-2 pb-2', isIpad ? 'block' : 'min-[1175px]:cf-hidden')}
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex">
          {hamburgerMenu ?? <HamburgetMenu />}
          {renderAccountItems()}
        </div>
        <a
          href={logoHref}
          className="max-w-[100px] text-center text-[16px] font-bold leading-4 md:max-w-full"
        >
          Creative Fabrica
        </a>
        {isAuthLoading ? <span /> : <HeaderCTA />}
      </div>
      {isAiSearchEnabled ? (
        <SearchAutocomplete aiSearchSlot={getAiSearchButton} />
      ) : (
        <SearchAutocomplete />
      )}
    </div>
  )
}
